import { StatsigClient } from '@statsig/js-client';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';

import { getCookie } from '../../general/utils/cookies';

const SIDECAR_BASE_URL = 'https://cdn.jsdelivr.net/npm/statsig-sidecar-v2-beta/dist/index.min.js';

export const loadStatsigSidecar = (clientKey: string): void => {
  const script = document.createElement('script');
  script.src = `${SIDECAR_BASE_URL}?apikey=${clientKey}`;
  script.async = true;
  document.head.appendChild(script);
};

export const initializeStatsigSessionReplay = (clientKey: string): void => {
  const stableID = getCookie('statsig_stable_id');
  const user = stableID ? { customIDs: { stableID } } : {};
  const client = new StatsigClient(clientKey, user, {
    plugins: [new StatsigSessionReplayPlugin(), new StatsigAutoCapturePlugin()],
  });
  void client.initializeAsync();
};
